enum ActivityStatus {
    Draft = 5,
    Planned = 10,
    Completed = 90,
    Cancelled = 95,
    Deleted = 100
}

export default ActivityStatus;

export const ActivityStatusLabels: { [key: number]: string } = {
    [ActivityStatus.Draft]: 'Draft',
    [ActivityStatus.Planned]: 'Planned',
    [ActivityStatus.Completed]: 'Completed',
    [ActivityStatus.Cancelled]: 'Cancelled',
    [ActivityStatus.Deleted]: 'Deleted'
};

export const ActivityStatusColors: { [key: number]: string } = {
    [ActivityStatus.Draft]: 'orange',
    [ActivityStatus.Planned]: 'blue',
    [ActivityStatus.Completed]: 'green',
    [ActivityStatus.Cancelled]: 'grey',
    [ActivityStatus.Deleted]: 'red'
};
